import React from 'react'
import ContentVideoPlayer from '../../../components/ContentVideoPlayer'
import LazyLoad from 'react-lazyload'
import { lazyload } from '../../../utils/style'

const Video = ({
  container: Container,
  videoId,
  title,
  coverImages,
  pageType
}) => (
  <Container my={pageType === 'article' ? [30] : [60, 100, 130]}>
    <LazyLoad offset={lazyload.offset} height={650} once>
      <ContentVideoPlayer
        id={videoId}
        text={title}
        img={
          coverImages &&
          coverImages.widgets &&
          coverImages.widgets[0] &&
          coverImages.widgets[0].crops &&
          coverImages.widgets[0].crops[0] &&
          coverImages.widgets[0].crops[0].src
        }
      />
    </LazyLoad>
  </Container>
)

export default Video
